<template>
  <div>
    <LmComponentLoading v-if="isLoading" fixed />
    <div
      class="d-flex flex-column justify-content-between vh-100"
      v-if="!documentSignedFeedback && !tokenExpiredFeedback"
    >
      <header id="lm-header">
        <div class="navbar-custom d-flex justify-content-between align-items-center">
          <div>
            <img :src="headerLogo" alt="Logo" class="logo-img">
          </div>
          <div class="d-flex" style="gap: 15px">
            <LmButton
              v-if="canBeRejectedByMe"
              class="mb-0"
              buttonClass="btn-danger"
              value="Rechazar"
              @click="onReject"
              :disabled="!canBeRejectedByMe || isLoading"
              requireConfirmation
            />
            <LmButton
              v-if="canBeReviewedByMe"
              :value="$t('approve')"
              class="mb-0"
              type="button"
              buttonClass="btn-success"
              @click="onReview()"
              :disabled="!canBeReviewedByMe || isLoading"
            />
            <LmButton
              v-if="canBeSignedByMe"
              class="mb-0"
              buttonClass="btn-success"
              value="Firmar"
              @click="onSign"
              :disabled="!canBeSignedByMe || isLoading"
            />
            <div class="document-signed-alert" v-if="documentWasSignedByMe">
              <i class="mdi mdi-check-circle-outline"></i>
              Documento Firmado
            </div>
          </div>
        </div>
      </header>
      <div v-if="!isOnEditableStatus && documentData">
        <div class="wrapper-content py-4" v-if="documentData">
          <h2 class="mb-4">{{documentData.documentName}}</h2>
          <div class="row w-100 mx-0">
            <!-- <div class="col-sm-12 col-md-12 w-100 my-4">
              <h2 class="m-0">{{form.documentName}}</h2>
              <a-steps :current="form.documentSteps.position" size="small" direction="horizontal">
                <a-step
                  class="mt-4"
                  v-for="(item, index) in form.documentSteps.items"
                  :key="`step-${index}`"
                  :title="item.title" :description="item.description"
                />
                </a-steps>
            </div> -->
            <iframe id="pdfViewer" :src="documentData.documentInPdf.src" width="100%" :height="700"/>
          </div>
        </div>
      </div>
      <LmSvgIcon
        v-if="isOnEditableStatus"
        icon="LmEditableIcon"
        wrapperClass="my-4 d-flex align-items-center flex-column"
        text="El documento esta siendo revisado por su creador."
        width="15em"
      />
      <div v-if="appUsageTermsRejectedFeedback">
        <LmSvgIcon
          icon="LmTermsIcon"
          wrapperClass="my-4 d-flex align-items-center flex-column"
          text="Debes aceptar los Terminos y Condiciones para continuar."
          width="15em"
        />
        <LmButton
          buttonClass="btn-outline-primary"
          class="d-flex justify-content-center"
          value="Ver terminos y condiciones"
          @click="validateTyC"
        />
      </div>
      <LmFooter />
    </div>
    <div class="full-alert" v-if="documentWasSignedByMe && documentSignedFeedback">
      <div class="close-btn" @click="documentSignedFeedback = false">
        <i class="mdi mdi-close"></i>
      </div>
      <div class="message w-50 text-center">
        <i class="mdi mdi-check-circle-outline"></i>
        <h3>Documento Firmado</h3>
        <p>¿Sabías que gestionando tus documentos de forma digital contribuis a reducir la deforestación y ahorrar agua? <b-link href="https://lumbredocs.com.ar" target="_blank" class="lm-link">Obtené mas información</b-link></p>
        <!-- <button
          class="lm-button"
          :disabled="iAmRecipient"
          @click="onAddMeToRecipients"
        >
          <template v-if="!isAcctionProcessing">
            {{ iAmRecipient ? 'Recibirás el documento por mail al finalizarse' : 'Quiero recibir el documento al finalizarse' }}
          </template>
          <template v-else>
            <i class="mdi mdi-loading lm-button-loading"></i>
          </template>
        </button> -->
        <div class="mt-4">
          <img :src="$store.state.settings.logoHomeImg" height="30px" alt="Logo" class="py-2">
        </div>
      </div>
    </div>
    <div class="full-alert danger" v-if="tokenExpiredFeedback">
      <div class="message w-50 text-center">
        <i class="mdi mdi-block-helper"></i>
        <h3>El Enlace Expiró</h3>
        <p>¿Sabías que gestionando tus documentos de forma digital contribuis a reducir la deforestación y ahorrar agua? <b-link href="https://lumbredocs.com.ar" target="_blank" class="lm-link">Obtené mas información</b-link></p>
        <!-- <button
          class="lm-button"
          :disabled="tokenRequested"
          @click="onRequestToken"
        >
          <template v-if="!isAcctionProcessing">
            {{ tokenRequested ? 'Nuevo enlace solicitado' : 'Quiero recibir un nuevo enlace' }}
          </template>
          <template v-else>
            <i class="mdi mdi-loading lm-button-loading"></i>
          </template>
        </button> -->
        <div class="mt-4">
          <img :src="$store.state.settings.logoHomeImg" height="30px" alt="Logo" class="py-2">
        </div>
      </div>
    </div>
    <lmConfirmationModal
      ref="lmConfirmationModalFirmarToken" title="Aviso"
      :message="confirmationModalMsg"
    />
    <LmSendOTP
      ref="lmValidationModalFirmarToken" title="Aviso"
      message="Un código fue enviado a su mail, por favor ingreselo a continuación." @ok="setToken"
    />
    <b-modal
      id="tyc-modal"
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      scrollable
    >
      <small>Version: {{ appUsageTerms.version }}</small>
      <div v-html="appUsageTerms.termsAndConditions"></div>
      <div v-html="appUsageTerms.privacyPolicies"></div>
      <template #modal-footer>
        <b-button variant="danger" disabled @click="onRejectTyC">Rechazar</b-button>
        <b-button variant="success" disabled @click="onApproveTyC">Aceptar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
// Components
import LmButton from '@/components/form/elements/LmButton'
import LmSendOTP from '@/components/modals/LmSendOTP'
import lmConfirmationModal from '@/components/modals/LmConfirmationModal'
import LmFooter from '@/components/LmFooter'

// Vuex
import { mapState, mapMutations } from 'vuex'

// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmToasts],
  components: {
    LmButton,
    LmSendOTP,
    lmConfirmationModal,
    LmFooter
  },
  data () {
    return {
      isAcctionProcessing: false,
      isLoading: false,
      documentData: null,
      customization: null,
      otpToken: null,
      documentSignedFeedback: false,
      tokenExpiredFeedback: false,
      appUsageTermsRejectedFeedback: false,
      tokenRequested: false
    }
  },
  computed: {
    ...mapState('settings', ['appUsageTerms']),
    headerLogo () {
      return this.customization?.appLogo1 ? process.env.VUE_APP_API_URL_STATIC_ASSETS + this.customization?.appLogo1?.path : this.$store.state.settings.logoLumbreDocs || null
    },
    canBeSignedByMe () {
      return this.documentData?.canBeSignedByMe || false
    },
    canBeRejectedByMe () {
      return this.documentData?.canBeRejectedByMe || false
    },
    canBeReviewedByMe () {
      return this.documentData?.canBeReviewedByMe || false
    },
    confirmationModalMsg () {
      if (this.canBeSignedByMe) {
        return 'Va a iniciar el proceso de firma electrónica del documento.  ¿Está seguro?'
      }
      if (this.canBeReviewedByMe) {
        return 'Va a iniciar el proceso de revisión electrónica del documento.  ¿Está seguro?'
      }
    },
    documentWasSignedByMe () {
      return this.documentData?.wasSignedByMe || false
    },
    iAmRecipient () {
      return this.documentData?.iAmRecipient || false
    },
    isOnEditableStatus () {
      return this.documentData?.isOnEditableStatus || false
    }
  },
  methods: {
    ...mapMutations('settings', ['mutateAppUsageTerms']),
    async onReject () {
      this.isLoading = true
      try {
        await commonsApi.axiosPostWrapper('/documents/reject-from-external', {
          token: this.$route.params.token
        })
        this.lmToastSuccessMessage(`Se rechazó ${this.documentData?.documentName || ' el documento'} correctamente.`, 'Documento rechazado.')
        this.documentData.canBeSignedByMe = false
        this.documentData.canBeRejectedByMe = false
        this.documentData.canBeReviewedByMe = false
        this.documentData.isOnEditableStatus = true
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onReview () {
      try {
        this.isLoading = true
        await this.$refs.lmConfirmationModalFirmarToken.lmShow()
        await commonsApi.axiosPostWrapper('/documents/generateotp-from-external', {
          token: this.$route.params.token
        })
        this.$refs.lmValidationModalFirmarToken.setIsCommentProps(true, true, 'Codigo', 'token')
        await this.$refs.lmValidationModalFirmarToken.lmShow()
        await commonsApi.axiosPostWrapper('/documents/review-from-external', {
          token: this.$route.params.token,
          otpToken: this.otpToken
        })
        this.lmToastSuccessMessage(`Se revisó ${this.documentData?.documentName || ' el documento'} correctamente.`, 'Documento revisado.')
        this.documentData.canBeSignedByMe = false
        this.documentData.canBeRejectedByMe = false
        this.documentData.canBeReviewedByMe = false
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onSign () {
      try {
        this.isLoading = true
        await this.$refs.lmConfirmationModalFirmarToken.lmShow()
        if (
          this.documentData.documentType.typeSignature === 'electronic' ||
          this.documentData.documentType.typeSignature === 'electronic_without_otp'
        ) {
          await commonsApi.axiosPostWrapper('/documents/generateotp-from-external', {
            token: this.$route.params.token
          })
          this.$refs.lmValidationModalFirmarToken.setIsCommentProps(true, true, 'Codigo', 'token')
          await this.$refs.lmValidationModalFirmarToken.lmShow()
          await commonsApi.axiosPostWrapper('/documents/sign-from-external', {
            token: this.$route.params.token,
            otpToken: this.otpToken
          })
          this.lmToastSuccessMessage(`Se firmó ${this.documentData?.documentName || ' el documento'} correctamente.`, 'Documento firmado.')
        } else if (this?.signatureType === 'digital') {
          // Todo.
        }

        this.documentData.canBeSignedByMe = false
        this.documentData.canBeRejectedByMe = false
        this.documentData.wasSignedByMe = true
        this.documentSignedFeedback = true
      } catch (error) {
        console.log(error)
        this.lmToastDangerMessage(error.response.data.message, 'Error al firmar')
      } finally {
        this.isLoading = false
      }
    },
    setToken (data) {
      this.otpToken = data.comment
    },
    async onAddMeToRecipients () {
      try {
        this.isAcctionProcessing = true
        await commonsApi.axiosPostWrapper('/documents/add-external-to-recipients', {
          token: this.$route.params.token
        })
        this.documentData.iAmRecipient = true
      } catch (error) {
        console.log(error)
      } finally {
        this.isAcctionProcessing = false
      }
    },
    async onRequestToken () {
      try {
        this.isAcctionProcessing = true
        await commonsApi.axiosPostWrapper('/documents/external-request-token', {
          id: this.$route.params.id
        })
        this.tokenRequested = true
      } catch (error) {
        console.log(error)
      } finally {
        this.isAcctionProcessing = false
      }
    },
    async validateTyC () {
      if (process.env?.VUE_APP_ENABLE_TYC !== 'yes') {
        return true
      }
      try {
        const response = await commonsApi.axiosGetWrapper(`/tyc/validate-from-external/${this.$route.params.token}`)
        this.mutateAppUsageTerms(response.data.doc)
        if (!response.data.ok) {
          this.$bvModal.show('tyc-modal')
          this.$nextTick(() => {
            const modal = document.querySelector('#tyc-modal .modal-body')
            if (modal) {
              modal.addEventListener('scroll', () => {
                const documentHeight = modal.scrollHeight - modal.offsetHeight - 1
                const currentScroll = modal.scrollTop
                const modifier = 80
                if (currentScroll + modifier > documentHeight) {
                  const buttons = document.querySelectorAll('#tyc-modal .modal-footer button')
                  for (const node of buttons) {
                    node.disabled = false
                    node.classList.remove('disabled')
                  }
                }
              })
            }
          })
          return false
        }
        return true
      } catch (error) {
        console.log(error)
        if (error.response.data.message.name === 'TokenExpiredError') {
          this.tokenExpiredFeedback = true
        }
        return false
      }
    },
    async onApproveTyC () {
      try {
        await commonsApi.axiosPutWrapper('/tyc/approve-from-external', {
          id: this.appUsageTerms._id,
          token: this.$route.params.token
        })
        this.$bvModal.hide('tyc-modal')
        await this.loadDocument()
        this.appUsageTermsRejectedFeedback = false
      } catch (error) {
        // TODO. Que pasaria aca?
        console.log(error)
      }
    },
    async onRejectTyC () {
      // TODO. Que pasaria aca?
      console.log('Rechazaste los terminos y condiciones.')
      this.appUsageTermsRejectedFeedback = true
      this.$bvModal.hide('tyc-modal')
    },
    async loadDocument () {
      try {
        this.isLoading = true
        const res = await commonsApi.axiosGetWrapper(`/documents/get-from-external/${this.$route.params.token}`)
        this.documentData = res.data.documentData
        this.customization = res.data.customization
        if (this.documentWasSignedByMe) {
          this.documentSignedFeedback = true
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      const result = await this.validateTyC()
      if (result) {
        await this.loadDocument()
      } else {
        this.appUsageTermsRejectedFeedback = true
      }
    } catch (error) {
      if (error.response.data.message.name === 'TokenExpiredError') {
        this.tokenExpiredFeedback = true
      }
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style lang="sass" scoped>
@keyframes spin
  from
    transform: rotate(0deg)
  to
    transform: rotate(360deg)
.logo-img
  max-width: 200px
  max-height: 50px
.document-signed-alert
  color: white
  background: rgb(1,210,68)
  background: linear-gradient(90deg, rgba(1,210,68,1) 0%, rgba(0,210,197,1) 100%)
  border-radius: 7px
  padding: .4rem 1rem
  & > i
    font-size: 1rem
.full-alert
  color: white
  background: rgb(1,210,68)
  background: linear-gradient(90deg, rgba(1,210,68,1) 0%, rgba(0,210,197,1) 100%)
  position: absolute
  top: 0
  bottom: 0
  left: 0
  right: 0
  display: flex
  justify-content: center
  align-items: center
  &.danger
    background: rgb(210,60,1)
    background: linear-gradient(90deg, rgba(210,60,1,1) 0%, rgba(210,0,96,1) 100%)
  .lm-link
    display: inline
    background: transparent
    color: white
    border: none
    border-bottom: 1px solid rgba(255, 255, 255, .4)
  .lm-button
    min-width: 200px
    text-transform: uppercase
    background-color: white
    color: black
    border-radius: 20px
    border: none
    padding: 8px 20px
    font-weight: bold
    transition: all .4s ease-in-out
    &:disabled
      cursor: not-allowed
      background-color: rgba(232, 232, 232, .9)
      &:hover
        transform: scale(1)
        box-shadow: none
    &:hover
      transform: scale(1.02)
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15)
    .lm-button-loading::before
      font-weight: bold
      animation-name: spin
      animation-duration: 1000ms
      animation-iteration-count: infinite
      animation-timing-function: linear
  .message
    & > p
      font-size: 1rem
    & > i
      font-size: 4.4rem
  .close-btn
    font-size: 2rem
    cursor: pointer
    position: fixed
    top: 30px
    right: 30px
    transition: ease-in-out .4s all
    &:hover
      transform: scale(1.2)
</style>
